import React from 'react';
import SignupContainer from '../components/signup.container';

const SignupPage: React.FC = () => <SignupContainer />;

export default SignupPage;
